import { injectedFieldServerError } from '@/utils';

import { TValues } from './type';

export const mapPropsToValues = (values: TValues) => {
	const {
		isActivatedApplicantNoti,
		isActivatedFranchiseNoti,
		isActivatedExpApplicantSms,
		isActivatedExpApplicantNoti,
	} = values;

	return {
		...injectedFieldServerError({
			isActivatedApplicantNoti: isActivatedApplicantNoti ?? true,
			isActivatedFranchiseNoti: isActivatedFranchiseNoti ?? true,
			isActivatedExpApplicantSms: isActivatedExpApplicantSms ?? true,
			isActivatedExpApplicantNoti: isActivatedExpApplicantNoti ?? true,
		}),
	};
};
